var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.date)?_c('span',{staticClass:"vue-moments-ago"},[_vm._v(_vm._s(_vm.$t(_vm.prefix))+" "+_vm._s(_vm.humanFormatted)+" "+_vm._s(_vm.$t(_vm.suffix)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }